/*
 * State Event Report Date Service
 * Angular module: trackerbase-app.services.state-event-report-data-service
 * Exposed Service: StateEventReportData
 *
 */

import moment from "moment-timezone";
import angular from "angular";

import Assert from "tbAssert";
import AllTrackingStatusesServiceModule from "tbClient/services/AllTrackingStatusesService";
import CalendarGlobalViewServiceModule from "tbClient/services/CalendarGlobalViewService";
import ServerFilterProcessorServiceModule from "tbClient/services/ServerFilterProcessorService";
import TbAppConfigDataServiceModule from "../config/tb-app-config/TbAppConfigDataService";

import State from "../models/State";
import EventFilter from "tbClient/models/EventFilter";

const mHttpSvc = new WeakMap();
const mQSvc = new WeakMap();
const mServerFilterProcessorSvc = new WeakMap();
const mTrackingStatuses = new WeakMap();
const mGlobalViewSvc = new WeakMap();

const mTbServerBaseUrl = new WeakMap();

class StateEventReportDataService {
    constructor($http, $q, AllTrackingStatuses, CalendarGlobalViewService, ServerFilterProcessor, TbAppConfigDataService) {
        Assert.StrictAssert($http != null, "Assertion Failure: Missing Http Service Dependency");
        Assert.StrictAssert($q != null, "Assertion Failure: Missing Q Service Dependency");
        Assert.StrictAssert(AllTrackingStatuses != null, "Assertion Failure: Missing Tracking Statuses Service Dependency");
        Assert.StrictAssert(CalendarGlobalViewService != null, "Assertion Failure: Missing Global View Service Dependency");
        Assert.StrictAssert(ServerFilterProcessor != null, "Assertion Failure: Missing Server Filter Processor Service Dependency");
        Assert.StrictAssert(TbAppConfigDataService != null, "Assertion Failure: Missing TrackerBase Application Configuration Data Service Dependency");

        mHttpSvc.set(this, $http);
        mQSvc.set(this, $q);
        mTrackingStatuses.set(this, AllTrackingStatuses);
        mGlobalViewSvc.set(this, CalendarGlobalViewService);
        mServerFilterProcessorSvc.set(this, ServerFilterProcessor);
        mTbServerBaseUrl.set(this, TbAppConfigDataService.tbServerBaseUrl);

        this._serviceName = "StateEventReportDataService";
    }

    toString() {
        return this._serviceName;
    }

    getEventCountReportData(startMoment, endMoment) {
        if ((!moment.isMoment(startMoment)) ||
            (!moment.isMoment(endMoment)))
        {
            throw new TypeError(
                "StateEventReportDataService: Invalid parameters for getEventCountReportData"
            );
        }
        const trackingStatusesSvc = mTrackingStatuses.get(this);
        const globalViewSvc = mGlobalViewSvc.get(this);
        const eventQueryFilter = new EventFilter({});
        eventQueryFilter.rangeStart = startMoment;
        eventQueryFilter.rangeEnd = endMoment;

        //let eventQueryParam = `and||and||eventstartafter|${startMoment.toISOString()}||eventstartbefore|${endMoment.toISOString()}||or||status|Tracked - Reported||status|Tracked - Access Denied||`;
        const trackedStatuses = [
            "Tracked - Reported",
            "Tracked - Access Denied"
        ].map(
            (tsName) => trackingStatusesSvc.getFromName(tsName).trackingStatusId
        );
        eventQueryFilter.includeStatusFilter.push(...trackedStatuses);

        const currentGlobalView = globalViewSvc.getCurrentView();
        const eventQueryDataSourceFilter = eventQueryFilter.dataSourceFilter(currentGlobalView.rule);
        const eventServerFilterQuery = mServerFilterProcessorSvc.get(this).ProcessFilterForServer(eventQueryDataSourceFilter, "||");

        return mHttpSvc.get(this)({
            url: `${mTbServerBaseUrl.get(this)}/api/states/datareports/stateevents`,
            method: "GET",
            params: { q: eventServerFilterQuery },
            isArray: false
        })
        .then(
            (response) => {
                let serverResponseData = response.data;
                if (serverResponseData != null) {

                    let stateReportData = {
                        eventReportData: [],
                        eventTotalCount: 0
                    };

                    serverResponseData.ReportData.forEach(function(reportDataElement) {
                        stateReportData.eventReportData.push({
                            state: State.FromServerState(reportDataElement.State),
                            stateEventCount: reportDataElement.StateEvents
                        });

                        stateReportData.eventTotalCount += reportDataElement.StateEvents;
                    });

                    return stateReportData;
                }
                else {
                    return mQSvc.get(this).reject("Server response data missing or invalid.");
                }
            },
            (errorResponse) => {
                return mQSvc.get(this).reject(errorResponse);
            }
        );
    }
}

StateEventReportDataService.$inject = [
    "$http",
    "$q",
    "AllTrackingStatuses",
    "CalendarGlobalViewService",
    "ServerFilterProcessor",
    "TbAppConfigDataService"
];

export default angular
    .module("trackerbase-app.services.state-event-report-data-service", [
        AllTrackingStatusesServiceModule,
        CalendarGlobalViewServiceModule,
        ServerFilterProcessorServiceModule,
        TbAppConfigDataServiceModule
    ])
    .service("StateEventReportData", StateEventReportDataService)
    .name;



//////////////////
// WEBPACK FOOTER
// ./src/services/StateEventReportDataService.js
// module id = VYPp
// module chunks = 1